__turbopack_context__.v({
  "backButton": "BackButton-module-scss-module__buN0ga__backButton",
  "iconBackButton": "BackButton-module-scss-module__buN0ga__iconBackButton",
  "text": "BackButton-module-scss-module__buN0ga__text",
  "textBackButton": "BackButton-module-scss-module__buN0ga__textBackButton",
  "wrap": "BackButton-module-scss-module__buN0ga__wrap",
});
